import { render } from "./RelatedProducts.vue?vue&type=template&id=2358489b&ts=true"
import script from "./RelatedProducts.vue?vue&type=script&lang=ts"
export * from "./RelatedProducts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__